<template>
  <footer class="footer">
    <p class="footer__copyright">
      © {{ year }} Lívia Almeida.
      {{ t('footer.rights') }}
    </p>
  </footer>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const year = new Date().getFullYear();
</script>

<style lang="scss" scoped>
@use '@/styles/mixins';
@use '@/styles/screens';

.footer {
  padding: 24px;

  @include screens.tablet {
    padding: 32px;
  }
}

.footer__copyright {
  @include mixins.monotext;
}
</style>
